import styled from '@emotion/styled';
import shouldForwardProp from '@styled-system/should-forward-prop';
import {
  background,
  BackgroundProps,
  border,
  BorderProps,
  color,
  compose,
  display,
  DisplayProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  shadow,
  ShadowProps,
  space,
  SpaceProps,
  typography,
  TypographyProps,
} from 'styled-system';

import {
  ColorProps,
  CoreBaseProps,
  defineWithTheme,
  WithoutCollidingProps,
} from '../../theming';

export interface BaseImgProps
  extends CoreBaseProps,
    BackgroundProps,
    BorderProps,
    ColorProps,
    DisplayProps,
    LayoutProps,
    PositionProps,
    ShadowProps,
    SpaceProps,
    TypographyProps {}

type NonCollidingImageProps = WithoutCollidingProps<BaseImgProps, 'img'>;

type NonCollidingImageKeys = keyof NonCollidingImageProps;

export const Image = styled<'img', NonCollidingImageKeys>('img', {
  shouldForwardProp: (prop): prop is NonCollidingImageKeys =>
    shouldForwardProp(prop as NonCollidingImageKeys),
})<BaseImgProps>(
  defineWithTheme('images'),
  compose(
    background,
    border,
    color,
    display,
    layout,
    position,
    shadow,
    space,
    typography
  )
);

export type ImageProps = React.ComponentPropsWithRef<typeof Image>;
